import { Button } from '@mui/material';
import React from 'react';

export default function AppButton({ onClick, label = "", fullWidth }) {

    return <Button onClick={onClick} variant="contained" fullWidth={fullWidth} >{label}</Button>
}